import {GrupoSelect} from '../grupo/grupo-select.model';

export class Login {
  login?: string;
  senha?: string;
  grupo?: GrupoSelect;
}
